import { render, staticRenderFns } from "./TopBarSettings.vue?vue&type=template&id=4e62d9f3&"
import script from "./TopBarSettings.vue?vue&type=script&lang=js&"
export * from "./TopBarSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\DIA-funsporthandel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e62d9f3')) {
      api.createRecord('4e62d9f3', component.options)
    } else {
      api.reload('4e62d9f3', component.options)
    }
    module.hot.accept("./TopBarSettings.vue?vue&type=template&id=4e62d9f3&", function () {
      api.rerender('4e62d9f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/widgets/TopBarSettings.vue"
export default component.exports